import Pagination from '../Pagination'
import Sort from '../SortReq'

export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    businessUnit: other.businessUnit || null,
    buIds: other.buIds || null,
    orgIds: other.orgIds || null,
    type: other.type || null,
    account: other.account || null,
    status: other.status || null,
    realType: other.realType || null,
    approved: other.approved || null,
    userIds: other.userIds || [],
    action: other.action || null,
    maxAmount: other.maxAmount || null,
    minAmount: other.minAmount || null,
    // Booleans must survive an explicit false (e.g. the retention drill's isFtd:false).
    // The "No FTD / STD" checkbox folds into BOTH flags as explicit false.
    isFtd: other.noFtdStd ? false : (other.isFtd == null ? null : other.isFtd),
    isStd: other.noFtdStd ? false : (other.isStd == null ? null : other.isStd),
    isTest: other.isTest == null ? null : other.isTest,
    // TXF (action TAXES) rows: false = hidden (the table's default), true = shown
    isTxf: other.isTxf == null ? null : other.isTxf,
    // The single Source switch maps onto the backend's fromCrm/fromWebsite
    // pair (CRM = creatorUserId set, WEBSITE = creatorUserId null).
    source: other.source || null,
    fromCrm: other.source === 'CRM' ? true : (other.fromCrm == null ? null : other.fromCrm),
    fromWebsite: other.source === 'WEBSITE' ? true : (other.fromWebsite == null ? null : other.fromWebsite),
    financeStatus: other.financeStatus || null,
    statusUserIds: other.statusUserIds || null,
    clientEmail: other.clientEmail || null,
    // registrationTime: other.registrationTime || {start: null, end: null},
    affiliateId: other.affiliateId || [],
    registrationTime: other.registrationTime || { start: null, end: null },
    // Range on the status-change (approval) moment — insights approvals drill.
    operationTime: other.operationTime || { start: null, end: null },
    //Search
    search: other.search || '',
    // The filter panel stores the picked client under the FLAT key
    // 'clientDetails.clientId' — fold it into the nested object the backend
    // reads, or the client filter silently does nothing.
    clientDetails: other['clientDetails.clientId']
        ? { ...(other.clientDetails || {}), clientId: other['clientDetails.clientId'] }
        : (other.clientDetails || {}),
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort()
  }
}
